import { Link } from "react-router-dom";

/**
 * Auto-routes to internal React Router <Link> when href starts with "/",
 * otherwise renders an external <a target="_blank">. Lets us swap Zeffy
 * constants from "/contact" → real Zeffy URLs in one place when live.
 */
export default function ZeffyLink({ href, className, children, testid }) {
  const external = typeof href === "string" && /^https?:\/\//i.test(href);
  if (external) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={className} data-testid={testid}>
        {children}
      </a>
    );
  }
  return (
    <Link to={href || "/contact"} className={className} data-testid={testid}>
      {children}
    </Link>
  );
}
